<template>
  <div class="orderDetailsPage">
    <headerNotice routerName="分销统计"></headerNotice>
    <!-- 搜索条 -->
    <div class="searchBox">
      <el-form :inline="true" :model="distributionStatisticsForm" class="demo-form-inline searchForm">
        <el-form-item style="margin-right:40px;" label="时间范围">
          <el-date-picker
            v-model="dateValue"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchConfirm">查询</el-button>
        </el-form-item>
        <!-- <el-form-item style="margin-left:40px;" label="快速查看">
          <el-button type="primary" @click="searchConfirm">最近七天</el-button>
          <el-button type="primary" @click="searchConfirm">最近一个月</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <div class="box">
    <div class="box-left">
        <div>{{distributionStatistics.orderQuantity}}</div>
        <div>分销订单数</div>
    </div>
      <div class="box-left">
           <div>￥{{distributionStatistics.totalOrderaAmount}}</div>
        <div>分销订单金额</div>
      </div>
        <div class="box-left">
             <div>￥{{distributionStatistics.totalCommissionAmount}}</div>
        <div>产生佣金</div>
        </div>
    </div>


  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
     SubordinateId:'',
      loading: true,
      SkipCount: 0,
      totalCount: 0, //总数据条数
      maxResultCount: 25, //默认一页显示的个数,
      currentPage: 1,
      baseUrl: this.$store.state.apiUrl,
     distributionStatisticsForm: {
        //搜索表单
       
        StartTime: "",
        EndTime: ""
      },
      distributionStatistics:{
        orderQuantity:'',
        totalCommissionAmount:'',
        totalOrderaAmount:'',
      },
      dateValue: "", //时间
 
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

 
     
    };
  },
  components: {
    headerNotice
  },
  created() {},
  mounted() {
    // this.GetDistribution()
    // console.log(this.$route.query,'row');
    // this.row = this.$route.query;
    // this.userName = this.row.userName;
    //  console.log(this.userName,'userName');
    //从路由提取userID
   this.getDatas()
  },
  methods: {
    // 日期条件查询
   
        searchConfirm() {
            if(this.dateValue) {
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    StartTime: this.dateValue[0], //商品开始时间
                    EndTime: this.dateValue[1] //商品结束时间
                });
            }else{
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    StartTime: null, //商品开始时间
                    EndTime: null //商品结束时间
                });
            }
            this.currentPage = 1
        },
    dateDataChange(val) {
      if (!val) {
        this.dateData = [];
      }
    },

    //
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Commission/GetDistributionStatistics",
        params: params,
        success(res) {
             console.log(res,'res');
          self.distributionStatistics = res;
          self.loading = false;
        },
        fail(res) {
          console.log(res);
          self.loading = false;
        }
      });
    },
   

   
  }
};
</script>

<style lang='scss' scoped>
.searchBox{
    background: #fff;
    padding-left: 30px;
    padding-top: 20px;
}
.box{
    background-color: #fff;
    width: 100%;
    // height: 200px;
    display: flex;
    justify-content: center;
    .box-left{
        padding: 100px 0;
    text-align: center;
    width: 33.33%;
    border-right: 1px solid #eee;
    }
}
</style>
